import FirstStep from './1'
import SecondStep from './2'
import ThirdStep from './3'
import FourStep from './4'

const Forms = [FirstStep, SecondStep, ThirdStep, FourStep]

export { Forms as default }
